import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function itemNameValidator(
  ownItems: string[] = [],
  sharedItems: string[] = [],
  permissionLevel: string,
  currentItemName?: string,
  isCurrentItemShared: boolean = false
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value?.trim().toLowerCase();

    if (!value) {
      return null;
    }

    const normalizedCurrentItemName = currentItemName?.toLowerCase()?.trim();

    const isDuplicateOwnItem = ownItems.some(
      (itemName) =>
        itemName.toLowerCase().trim() === value &&
        itemName.toLowerCase().trim() !== normalizedCurrentItemName
    );

    // Only exclude current item from shared check if it was originally shared
    const isDuplicateSharedItem = sharedItems.some((sharedItemName) => {
      const normalizedSharedName = sharedItemName.toLowerCase().trim();
      const isNameMatch = normalizedSharedName === value;
      const isEditingOwnSharedItem =
        isCurrentItemShared &&
        normalizedSharedName === normalizedCurrentItemName;
      return isNameMatch && !isEditingOwnSharedItem;
    });

    const hasDuplicate =
      permissionLevel === 'shared'
        ? isDuplicateOwnItem || isDuplicateSharedItem
        : isDuplicateOwnItem;

    return hasDuplicate ? { valueAlreadyExist: true } : null;
  };
}
